import { Rpc } from "./rpc";

export class UpcomingEventsRpc {

    public static list(): Promise<ListResponse> {
        return Rpc.GET("/rpc/upcomingevents/list");

    }

    private constructor() {}
}

export interface ListResponse {

    readonly items: ListItemDto[];

}

export interface ListItemDto {

    readonly icon: string;
    readonly iconColor: string;
    readonly title: string;
    readonly date: string;
    readonly description: string;
    readonly sortOrder: number;

}